<template lang="pug">
.buttons-filter-group
  .button-filter(
    v-for="entry in entries" 
    :key="entry.id"
    :class="{ active: entry.chosen }" 
    @click="handleClick(entry)"
    v-if="!entry.hidden"
  )
    .button-filter-name {{ entry.name }}
</template>

<script>
export default {
  name: "ButtonFilter",
  props: {
    entries: {
      type: Array,
      required: true,
    },
    queryKey: {
      type: String,
      required: true,
    },
    onlyEntries: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(entry) {
      this.$emit("item-click", entry, this.queryKey);
    },
  },
};
</script>

<style lang="stylus" scoped>
.buttons-filter-group
  display flex
  flex-wrap wrap
  gap 8px
  backface-visibility hidden
  transform translateZ(0)

.button-filter
  display flex
  align-items center
  padding 8px 12px
  border-radius 4px
  border 1px solid #CCD9E5
  background-color #ffffff
  font-size 14px
  font-weight 500
  cursor pointer
  width fit-content
  backface-visibility hidden
  will-change transform
  transform translateZ(0)

  &:hover
    border-color button-background-color

  &.active
    border-color button-background-color
    background-color button-background-color
    color #ffffff

    &:hover
      background-color button-background-color
      color #ffffff
</style>
